import { render } from "./ChatApp.vue?vue&type=template&id=5de0b4e1&scoped=true"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"

import "./ChatApp.vue?vue&type=style&index=0&id=5de0b4e1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de0b4e1"]])

export default __exports__